module.exports = __webpack_public_path__ + "static/media/KeepInTouch__Img.7a519198.svg";